import { create } from 'zustand'

export type RowActionButtonStoreType = {
    activeRowAction: string
    setActiveRowAction: (listingId: string) => void
}

const rowActionButtonStore = create<RowActionButtonStoreType>()((set) => ({
    activeRowAction: '',
    setActiveRowAction: (listingId: string) =>
        set({
            activeRowAction: listingId,
        }),
}))

export default rowActionButtonStore
